import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { ResourceBaseUrlBuilder } from './api/resource-base-url-builder';
import {
  getClientDdqRouteProductUidFromUrl,
  isClientDdqProductUrlPath,
  resolveClientDdqEmittentApiScopeFromSummaries,
} from './context/client-ddq-emittent-api-scope.util';
import { ClientDdqScopeCacheService } from './context/client-ddq-scope-cache.service';
import { OrganizationContextService } from './context/organization-context.service';
import { OrganizationQuery } from './organization/organization.query';
import { ProductSummaryQuery } from './product-summary/product-summary.query';
import { ProductQuery } from './product/product.query';
import { UserNamespacedResourceBaseUrlBuilder } from './user-namespaced-resource-base-url-builder.service';
import { standardizeUrl } from './utils';

/**
 * Builds the following backend URLs:
 *   - emittents/{emittent_uid}/products/{product_uid}
 */
@Injectable({ providedIn: 'root' })
export class ProductNamespacedResourceBaseUrlBuilder implements ResourceBaseUrlBuilder {
  constructor(
    private userNamespaceBuilder: UserNamespacedResourceBaseUrlBuilder,
    private productQuery: ProductQuery,
    private organizationContextService: OrganizationContextService,
    private organizationQuery: OrganizationQuery,
    private router: Router,
    private productSummaryQuery: ProductSummaryQuery,
    private clientDdqScopeCacheService: ClientDdqScopeCacheService,
  ) {}

  public buildBaseUrl(append?: string): string {
    const userNamespace = this.userNamespaceBuilder.buildBaseUrl();
    const ctx = this.organizationContextService.getContextValue();
    const org = this.organizationQuery.getActive();
    const routeProductUid = getClientDdqRouteProductUidFromUrl(this.router.url);
    const clientScope = resolveClientDdqEmittentApiScopeFromSummaries(
      org?.type,
      isClientDdqProductUrlPath(this.router.url) ? this.productSummaryQuery.getAll() : [],
    );
    const cachedClientScope = this.clientDdqScopeCacheService.getSnapshotForRouteProduct(routeProductUid);
    const productId =
      ctx?.context === 'fund-ddq-runs' && ctx.ddqProductUid
        ? ctx.ddqProductUid
        : (clientScope?.ddqProductUid ?? cachedClientScope?.ddqProductUid ?? this.productQuery.getActiveId());
    let url = `${userNamespace}/products/${productId}`;

    if (append) {
      url += `/${append}`;
    }

    return standardizeUrl(url);
  }
}
